import UserEdit from './UserEdit'

export default UserEdit;